import { Route, Routes, Navigate } from "react-router-dom";
import { Space } from "~/lib/types";
import RiskFactorsEntryPage from "~/entry-pages/space/security-model/risk-factors/RiskFactorsEntryPage";
import SlasEntryPage from "~/entry-pages/space/security-model/slas/SlasEntryPage";

type Props = {
  space: Space;
};

export const SecurityModelRoutes = ({ space }: Props) => (
  <Routes>
    <Route index element={<Navigate to="risk-factors" replace />} />
    <Route
      path="risk-factors"
      element={<RiskFactorsEntryPage space={space} />}
    />
    <Route path="slas" element={<SlasEntryPage />} />
  </Routes>
);
